import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopMediaInfoService } from '../top-media-info/top-media-info.service';

@Component({
  selector: 'mtm-download-asset-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="d-flex align-items-center m-1">
      <i class="mtm-icon mtm-icon-topic-download pointer" (click)="downloadAsset()"></i>
    </div>
  `,
  styles: [],
})
export class DownloadAssetButtonComponent {
  private readonly topMediaInfoService = inject(TopMediaInfoService);

  downloadAsset(): void {
    const subsectionPreview = this.topMediaInfoService.getSubsectionPreview();
    subsectionPreview?.sliderMediaPlayerComponent?.downloadAsset();
    this.topMediaInfoService.emitDownloadAsset();
  }
}
